function initHTMLTextareaTinymce(id, selector, minHeight, placeholder) {
  var id = id || uuidv4();

  app[id] = tinymce.init({
    license_key: 'gpl',
    selector: selector,
    base_url: '/js/vendor/tinymce',
    menubar: false,
    statusbar: false,
    plugins: ['lists', 'fullscreen', 'charmap', 'link', 'autoresize', 'autolink'],
    toolbar: 'undo redo | bold italic | bullist numlist | outdent indent | charmap | link unlink | removeformat | fullscreen',
    min_height: minHeight || 240,
    autoresize_bottom_margin: 0,
    placeholder: placeholder || '',
    valid_elements: "p,a[href|target],strong,b,em,i,div,br,ul,ol,dl,li",
    link_assume_external_targets: 'https',
    language: 'de',
    relative_urls: false,
    content_css: '/css/tinymce.css',
    forced_root_block: 'p',
    contextmenu: false,
    setup: function (editor) {
      editor.on('init', function (e) {
        requestAnimationFrame(function () {
          $(selector).val(editor.getContent());
        });
      });
      editor.on('input', function (e) {
        formUserInput = true;
        $(selector).val(editor.getContent());
        $(selector).parents('.input__wrapper').removeAttr('data-error');
        $(selector).parents('.input__wrapper').find('.input__error').html('');
      });
      editor.on('change', function (e) {
        $(selector).val(editor.getContent());
      });
    }
  });
}
